import { IShader, ShaderBase } from '../shader';
import { Scene, Material, PBRMetallicRoughnessMaterial, Color3, Texture } from '@babylonjs/core';
import { stringUtil } from '@/models/stringUtil';

export class ShaderHdf extends ShaderBase implements IShader {

    public diffuse: string = 'diffuse/hdf_diffuse.jpg';
    public normal: string = '';
    public avatar: string = '';
    public text: string = '';

    public get key(): string { return 'ShaderHdf'; }

    public getMaterial(scene: Scene, light: string): Material {
        const material = new PBRMetallicRoughnessMaterial('material', scene);
        material.baseColor = new Color3(0.88, 0.88, 0.88);
        material.metallic = 0.1;
        material.roughness = 0.4;

        if (this.diffuse) {
            const url = stringUtil.createDownloadUrl(this.diffuse);
            const baseTexture = new Texture(url, scene);
            baseTexture.coordinatesIndex = 0;
            baseTexture.uScale = 4;
            baseTexture.vScale = 4;
            material.baseTexture = baseTexture;
        }

        if (this.normal) {
            const url = stringUtil.createDownloadUrl(this.normal);
            const normalTexture = new Texture(url, scene);
            normalTexture.uScale = 4;
            normalTexture.vScale = 4;
            material.normalTexture = normalTexture;
        }

        if (light) {
            const url = stringUtil.createDownloadUrl(light);
            const lightmapTexture = new Texture(url, scene);
            lightmapTexture.coordinatesIndex = 1;
            lightmapTexture.vScale = -1;
            material.useLightmapAsShadowmap = true;
            material.lightmapTexture = lightmapTexture;
        }

        material.backFaceCulling = false;
        return material;
    }
}
